module.exports = __webpack_public_path__ + "static/media/quick.b4efada1.svg";